import { render, staticRenderFns } from "./MeasurementUnitEdit.vue?vue&type=template&id=603868d2&scoped=true"
import script from "./MeasurementUnitEdit.vue?vue&type=script&lang=js"
export * from "./MeasurementUnitEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603868d2",
  null
  
)

export default component.exports